export default __webpack_public_path__ + "static/media/26.4d8b6c4f.svg";